<template>
  <div class="page-template">
    <!--    <menu-list></menu-list>-->
    <div
      class="good-shelves content-table-box"
    >
      <div class="left" v-if="!userInfo.storeId">
        <div class="merchantName"> {{ userInfo && userInfo.merchantName }}</div>
        <el-tree
          ref="storeTree"
          :data="treeData"
          node-key="id"
          :highlight-current=true
          :props="defaultProps"
          @node-click="nodeClick"
        ></el-tree>
      </div>
      <div class="right">
        <page-template ref="pageTemplate"
                       :searchOptions="searchOptions"
                       :toolConfig="toolConfig"
                       :tableOptions="tableOptions"
                       @searchReset="searchReset"
        ></page-template>
      </div>
      <div class="cl"></div>
      <!--    多规格详情-->
      <el-dialog title="规格详情"
                 :visible.sync="specsDetailShow"
                 width="1000px"
                 height="2000px"
                 :close-on-click-modal="false"
      >
        <more-table
          v-if="specsDetailShow"
          ref="specsDetailColumns"
          :tableColumns="specsDetailColumns"
          :data="specsDetailData"
        >
        </more-table>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import api from "@/config/api";
  import moreTable from "@/components/business/moreTable";

  export default {
    components: {moreTable},
    data() {
      return {
        specsDetailShow: false,
        specsDetailData: [],
        specsDetailColumns: [
          {
            label: "规格名称",
            prop: "specsNameList",
            width: "100",
            align: "center",
          },
          {
            label: "规格条码",
            prop: "specsBarCode",
            align: "center",
            width: "150",
          },
          {
            prop: "buyPrice",
            label: "进价",
            align: "center",
            width: "100",
          },
          {
            prop: "retailPrice",
            label: "零售价",
            align: "center",
            width: "100",
          },
          {
            prop: "vipPrice",
            label: "会员价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallRetailPrice",
            label: "商城零售价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallVipPrice",
            label: "商城会员价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallPlusVipPrice",
            label: "商城Plus会员价",
            align: "center",
            width: "150",
          },
        ],
        goodListSelect: true,
        tableOptions: {
          menuListHidden: true,
          showSelect: true,
          indexShow: true,
          columns: [
            {
              label: "条码",
              prop: "barCode",
              width: "150",
              align: "center",
            },
            {
              label: "自编码",
              prop: "artNo",
              width: "100",
              align: "center",
            },
            {
              label: "商品名称",
              prop: "goodsName",
              width: "150",
              align: "center",
            },
            {label: '单位', prop: 'unitName', width: '60', align: 'center'},
            {
              label: '规格',
              prop: 'buyPrice',
              width: '90',
              align: 'center',
              deal: this.specsDetail,
              callback: this.specsClick
            },
            {
              label: "商品状态",
              prop: "status",
              width: "100",
              align: "center",
              enumData: this.$utils.getCacheStatus("asGoods.status"),
            },
            {
              label: "售价",
              prop: "retailPrice",
              width: "80",
              align: "center",
            },
            {
              label: "类别",
              prop: "goodsCategoryName",
              width: "100",
              align: "center",
            },
            {
              label: "品牌",
              prop: "goodsBrandName",
              width: "120",
              align: "center",
            },
            {
              label: "供应商",
              prop: "supplierName",
              width: "150",
              align: "center",
            },
            {
              label: "创建时间",
              prop: "createDttm",
              width: "150",
              align: "center",
            },
          ],
          url: '',
          param: {}
        },
        checkIndex: "",
        currentShopId: -1,
        userInfo: {},
        loading: false,
        defaultProps: {
          children: "children",
          label: "name",
        },
        searchOptions: {
          simple: [
            {
              label: "商品状态",
              prop: "status",
              type: "select",
              change: this.statusChange,
              // labelWidth: "70px",
              defaultValue:10,
              clearable:true,
              data: this.$utils.getCacheStatus("asGoods.status"),
              span: 12
            },
            {
              label: "条码",
              prop: "barCode",
              type: "input",
              span: 12,
              placeholder: '请输入条码',
            },
            {
              label: "类别",
              type: "cascader",
              prop: "goodsCategoryId",
              valueKey: "value",
              data: [],
              // labelWidth: "40px",
              url: api.archives.getCategoryTree,
              span: 6
            },
            {
              label: "品牌",
              prop: "goodsBrandId",
              type: "select",
              data: [],
              // labelWidth: "40px",
              url: api.archives.brand + '/query/brand',
              param: {storeId: null}
            },
            {
              label: "供应商",
              prop: "supplierId",
              type: "select",
              // labelWidth: "60px",
              data: [],
              url: api.archives.supplier + '/query/supplier',
              param: {storeId: null}
            },
          ],
        },
        toolConfig: [
          {
            label: "淘汰",
            code: "eliminate",
            callback: this.eliminate,
            filter: this.statusBtnShow
          },
          {
            label: "停购",
            code: "stopBuying",
            callback: this.stopBuying,
            filter: this.statusBtnShow
          },
          {
            label: "停售",
            code: "discontinued",
            callback: this.discontinued,
            filter: this.statusBtnShow
          },
          {
            label: "恢复",
            code: "recover",
            callback: this.recover,
            filter: this.statusBtnShow
          },
        ],
        treeData: [],
        goodsStatus: null
      };
    },
    created() {
      this.userInfo = this.$utils.getSysUser();
    },
    mounted() {
      let params = this.$refs.pageTemplate.getSimpleParams()
      if (!this.userInfo.storeId) {
        this.getStoreList();
      } else {
        // 刷新列表页
        this.tableOptions.url = api.archives.goodsStore
        this.tableOptions.param.storeId = this.userInfo.storeId
        this.$refs.pageTemplate.searchSubmit(params);
      }
      let status = this.searchOptions.simple.filter(v => v.prop == "status")[0].defaultValue
      this.statusChange({status: status})
    },
    methods: {
      // 搜索重置
      searchReset(formModel){
        formModel.status = 10
        let params = this.$refs.pageTemplate.getSimpleParams()
        this.$refs.pageTemplate.searchSubmit(params);
        this.statusChange({status: 10})
      },
      // 查看多规格详情
      specsDetail(row, column) {
        if (row.openSpecs) {
          return '<span class="td-click">多规格</span>'
        } else {
          if (row.specs) {
            return '<span>' + row.specs + '</span>'
          }
        }
      },
      // 点击
      specsClick(row) {
        if (row.openSpecs) {
          this.specsDetailData = []
          this.specsDetailShow = true
          this.$loading({})
          this.$axios.fetchPost(api.baseInfo.getSpecsList, {goodsId: row.id}).then((data) => {
            if (data.code == 200) {
              if (data.data && data.data.specsList) {
                this.$nextTick(() => {
                  this.specsDetailData = data.data.specsList
                })
              }
            }
          }).finally(() => {
            this.$loading({}).close()
          })
        }
      },
      statusBtnShow(btn) {
        if (!this.goodsStatus) return false;
        switch (btn.code) {
          case 'eliminate':
            return this.goodsStatus != 40;
          case 'stopBuying':
            return this.goodsStatus == 10 || this.goodsStatus == 20;
          case 'discontinued':
            return this.goodsStatus == 30 || this.goodsStatus == 10;
          case 'recover':
            return this.goodsStatus != 10;
        }
      },
      statusChange(formModel) {
        //正常: 淘汰、停购、停售10
        // 淘汰：正常 40
        // 停购：恢复、停售、淘汰 30
        // 停售：恢复、停购、淘汰 20
        this.goodsStatus = formModel.status;
      },
      eliminate() {
        this.changeStatus(40);
      },
      stopBuying() {
        this.changeStatus(30);
      },
      discontinued() {
        this.changeStatus(20);
      },
      recover() {
        this.changeStatus(10);
      },
      nodeClick(nodeData) {
        // this.$refs.pageTemplate.clearSearch()
        this.tableOptions.param.storeId = nodeData.id;
        let goodsBrandId = this.searchOptions.simple.filter(item => {
          return item.prop == 'goodsBrandId'
        })[0]
        let supplierId = this.searchOptions.simple.filter(item => {
          return item.prop == 'supplierId'
        })[0]
        goodsBrandId.data = []
        supplierId.data = []
        goodsBrandId.param.storeId = nodeData.id;
        supplierId.param.storeId = nodeData.id;
        this.$refs.pageTemplate.$refs.searchFormTemp.simpleClear();
        this.$refs.pageTemplate.$refs.searchFormTemp.initData();
        // this.$refs.pageTemplate.operationSuccess();
      },
      getStoreList() {
        this.$axios
          .fetchPost(api.system.seStore + "/list", {})
          .then((data) => {
            this.loading = false;
            if (data.code == 200) {
              if (data.data && data.data.length > 0) {
                data.data.unshift({name: '总部', id: -1})
                this.treeData = data.data;
                if (this.treeData.length == 0) return;
                //树组件重新渲染完毕再设置
                this.$nextTick(() => {
                  this.$refs.storeTree.setCurrentKey(this.treeData[0].id);
                });
                this.searchOptions.simple.filter(item => {
                  return item.prop == 'goodsBrandId'
                })[0].param.storeId = this.treeData[0].id;
                this.searchOptions.simple.filter(item => {
                  return item.prop == 'supplierId'
                })[0].param.storeId = this.treeData[0].id;
                this.$refs.pageTemplate.$refs.searchFormTemp.initData();
              }
              // 刷新列表页
              this.tableOptions.url = api.archives.goodsStore
              if (this.treeData && this.treeData.length > 0 && this.treeData[0].id) {
                this.tableOptions.param.storeId = this.treeData[0].id;
              }
              let params = this.$refs.pageTemplate.getSimpleParams()
              this.$refs.pageTemplate.searchSubmit(params);
              // this.$refs.pageTemplate.operationSuccess();
            } else {
              this.$message({message: data.msg, type: "error"});
            }
          });
      },
      //上架
      changeStatus(status) {
        let newListArr = []
        newListArr = this.$refs.pageTemplate.getTableSelectRow().map((item) => {
          return {
            id: item.id,
            status: status,
          };
        });
        if (newListArr.length === 0) {
          this.$message.warning('请选择要操作的数据')
        } else {
          this.$loading({text: '提交中，请稍后。。。'})
          this.$axios
            .fetchPost(api.archives.batchUpDate, {asGoodsList: newListArr})
            .then((data) => {
              if (data.code == 200) {
                if ((data.data = true)) {
                  this.$refs.pageTemplate.operationSuccess();
                  this.$notify({
                    type: "success",
                    title: '提交操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message({message: "操作成功！", type: "success"});
                }
              } else {
                this.$message({message: data.errorMsg, type: "error"});
              }
            }).finally(() => {
            this.$loading({}).close()
          })
        }
      },
    },
  };
</script>
<style scoped>
  .good-shelves.content-table-box .page-template {
    padding: 0px;
  }

  .merchantName {
    width: 100%;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
  }

  .good-shelves {
    padding: 5px;
    height: 100%;
    display: flex;
  }

  .good-shelves .left {
    width: 15%;
    margin-right: 10px;
    /*height: calc(100vh - 150px);*/
    height: 100%;
    overflow: scroll;
    box-sizing: border-box;
    padding: 5px;
    border-right: 1px solid #ccc;
  }

  .good-shelves .left .tree-type {
    margin-bottom: 10px;
  }

  .good-shelves .right {
    flex: 1;
    position: relative;
    width: calc(100% - 160px);
    height: 100%;
  }

  .good-shelves .el-table__row {
    cursor: pointer;
  }

  .good-shelves .table-header th,
  .good-shelves .el-table__header {
    height: 30px;
    line-height: 30px;
  }

  .good-shelves .btn-box {
    position: absolute;
    bottom: 2px;
    width: 100%;
    text-align: center;
    left: 0px;
    z-index: 1000;
    width: 100%;
    padding: 0;
    margin: 0;
    border: 0;
  }

  >>> .el-cascader {
    line-height: 30px;
  }

  >>> .el-form-item, .el-form-item .el-form-item {
    min-height: auto;
  }

  >>> .form-item-wrapper {
    display: block;
  }

  .page-template {
    padding-top: 0;
  }
</style>





// WEBPACK FOOTER //
// src/page/archives/goods/store/Mgmt.vue